import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ListMusic, Share2, Trash2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { usePlaylist } from "@/lib/playlist";
import { visitorId } from "@/lib/showcase";

// Floating bar on the showcase: visitor's playlist (localStorage) → save & share as /playlist/{id}.
export default function PlaylistBar() {
  const pl = usePlaylist();
  const nav = useNavigate();
  const [title, setTitle] = useState("");
  const [busy, setBusy] = useState(false);
  if (!pl.ids.length) return null;
  const share = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/playlists", { title: title.trim() || `My MusicFlow playlist (${pl.ids.length})`, track_ids: pl.ids, visitor: visitorId() });
      await navigator.clipboard?.writeText(data.url).catch(() => {});
      toast.success("Playlist saved — link copied.");
      nav(data.path);
    } catch (e) { toast.error(e.response?.data?.detail || "Could not save playlist"); }
    finally { setBusy(false); }
  };
  return (
    <div className="fixed bottom-4 inset-x-0 z-40 px-4 pointer-events-none" data-testid="playlist-bar">
      <div className="max-w-3xl mx-auto rounded-2xl border border-fuchsia-500/40 bg-background/90 backdrop-blur-xl shadow-2xl p-3 flex flex-wrap items-center gap-3 pointer-events-auto animate-in slide-in-from-bottom-4">
        <span className="inline-flex items-center gap-2 text-sm font-semibold text-fuchsia-200"><ListMusic size={16} /> My playlist <span className="font-mono text-xs rounded-full bg-fuchsia-500/20 px-2 py-0.5" data-testid="playlist-bar-count">{pl.ids.length}</span></span>
        <input value={title} onChange={(e) => setTitle(e.target.value.slice(0, 80))} placeholder="Playlist title (optional)" className="h-9 flex-1 min-w-[160px] rounded-md border border-border bg-card px-3 text-sm" data-testid="playlist-bar-title" />
        <button type="button" onClick={share} disabled={busy} className="inline-flex items-center gap-1.5 h-9 px-4 rounded-full bg-fuchsia-500 text-white text-sm font-semibold hover:bg-fuchsia-400 disabled:opacity-50" data-testid="playlist-bar-share">{busy ? <Loader2 size={14} className="animate-spin" /> : <Share2 size={14} />} Save & share</button>
        <button type="button" onClick={pl.clear} title="Clear" className="h-9 w-9 inline-flex items-center justify-center rounded-full border border-border text-muted-foreground hover:text-foreground" data-testid="playlist-bar-clear"><Trash2 size={14} /></button>
      </div>
    </div>
  );
}
